module.exports = __webpack_public_path__ + "static/media/SPONSORS (2).287a9c94.png";